import { graphql } from '@apollo/client/react/hoc';
import type { MutationFunction as MutationFn } from '@apollo/client/react/types/types';
import * as React from 'react';
import uuid from 'uuid';
import axios from 'axios';

import { buildForm } from 'components/File';
import API from 'lib/RemindAPI';
import errorLogger from 'utils/errorLogger';
import PUT_STUDENT_ID_LIST_MUTATION from '../queries/PutStudentIdListMutation.gql';
import type {
  putStudentIdList as MutData,
  putStudentIdListVariables as MutVariables,
} from '../queries/__generated__/putStudentIdList';
import ToastActions from 'actions/ToastActions';

export const PRIVATE_UPLOAD = true;

export type ChildrenProps = {
  onUploadSuccess: (file: any) => void;
  csvIsMatching: boolean;
  csvMatchError?: Error | null;
  uploadFile: (file: any, onUploadProgress: Function, onUploadSuccess: Function) => Promise<void>;
};

export type Props = {
  children: (props: ChildrenProps) => JSX.Element;
  onUploadSuccess: (data: { studentIdListUuid: string; csvName: string }) => void;
  selectedOrganizationUuid: string;
  // graphql mutations
  mutate: MutationFn<MutData, MutVariables>;
};

type State = {
  csvIsMatching: boolean;
  csvMatchError?: Error | null;
};

class TargetByStudentIdUploadPageContainer extends React.Component<Props, State> {
  state = {
    csvIsMatching: false,
    csvMatchError: null,
  };

  async uploadFile(file: any, onUploadProgress: Function, onUploadSuccess: Function) {
    const data = await API.request('/files', 'POST', {
      file: { name: file.name },
      private: PRIVATE_UPLOAD,
    });
    const form = buildForm(data.fields, file);
    await axios.post(data.upload_url, form, {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Function' is not assignable to type '(progre... Remove this comment to see the full error message
      onUploadProgress,
    });

    onUploadSuccess(data);
  }

  handlePutStudentIdList = (file: any) => {
    this.setState({ csvIsMatching: true });
    const studentListUuid = uuid.v4();
    this.props
      .mutate({
        variables: {
          input: {
            uuid: studentListUuid,
            fileUuid: file.id,
            organizationUuid: this.props.selectedOrganizationUuid,
          },
        },
      })
      .then(
        (response) => {
          this.setState({
            csvIsMatching: false,
          });

          const { results, error } = response?.data?.putStudentIdList || {};
          if (results) {
            this.props.onUploadSuccess({
              studentIdListUuid: results.uuid,
              csvName: file.fields.Filename,
            });
          }
          if (error) {
            this.setState({ csvMatchError: error as any });
          }
        },
        (err) => {
          this.setState({
            csvIsMatching: false,
          });
          ToastActions.showErrorToast(
            'Oops! Looks like something went wrong. Please try again later.'
          );
          console.error('TBSI - putStudentIdList error during handleUploadSuccess');
          console.warn(err);
        }
      )
      .catch(errorLogger('TBSI - putStudentIdList runtime error during handleUploadSuccess'));
  };

  render() {
    return this.props.children({
      onUploadSuccess: this.handlePutStudentIdList,
      csvIsMatching: this.state.csvIsMatching,
      csvMatchError: this.state.csvMatchError,
      uploadFile: this.uploadFile,
    });
  }
}

const withMutation = graphql<Props, MutData, MutVariables>(PUT_STUDENT_ID_LIST_MUTATION);

export { TargetByStudentIdUploadPageContainer };

export default withMutation(TargetByStudentIdUploadPageContainer) as any as React.ComponentType<
  Omit<Props, 'mutate'>
>;
